import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';

import FeeTotal from '../../../../models/FeeTotal';
import AddServicesUnits from '../../../../models/AddServicesUnits';

import customsStyles from './customsFee.module.css';
import commonAddServiceStyles from '../commonAdditionalService/commonAdditionalService.module.css';
import commonStyles from '../../../common/common.module.css';
import { formatCurrency } from '../../../../utils/currencyFormatter';

const TEXT_FIELD_PADDINGS: string = '8px 12px';
const styles = (theme: any) => ({

});

interface CustomsProps {
  classes: any;
  serviceDetails: AddServicesUnits;
  total: number;
  calculations: FeeTotal;
  cartItemWeight: number;
  handleChange: any;
  additionalInformation: string;
};

const CustomsFee = (props: CustomsProps) => {

  const { classes, serviceDetails, total, additionalInformation } = props;

  let minCostIsPerDay = serviceDetails.min_cost_per_day_usd != null;
  let minCost = minCostIsPerDay? serviceDetails.min_cost_per_day_usd: serviceDetails.min_cost_usd;

  return (
    <FormControl fullWidth={ true }>
      <div className={ customsStyles.flexContainer }>
        
        <div className={ commonStyles.inputLabelWrapper } >
          <label className={ commonStyles.inputLabel }> U.S. Customs Fee  </label>
          <TextField
            disabled
            value={ formatCurrency(serviceDetails.cost_usd, 2, '$') }
            label=""
            variant="outlined"
            inputProps={{ style: { padding: TEXT_FIELD_PADDINGS  } }}
            InputProps={{ classes: { notchedOutline: classes.overrideBorder } }}
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
          />
        </div>
      
        <div className={ commonStyles.inputLabelWrapper } >
          <label className={ commonStyles.inputLabel }>  Processing Fee </label>
          <TextField
            disabled
            label=""
            value={ formatCurrency(serviceDetails.processing_fee, 2, '$') }
            variant="outlined"
            inputProps={{ style: { padding: TEXT_FIELD_PADDINGS  } }}
            InputProps={{ classes: { notchedOutline: classes.overrideBorder } }}
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
          />
        </div>

        <div className={ commonStyles.inputLabelWrapper } >
          <label className={ commonStyles.inputLabel }> Transportation Fees  </label>
          <TextField
              disabled
              label=""
              value={ formatCurrency(serviceDetails.transportation_fee, 2, '$') + '/kg'}
              variant="outlined"
              inputProps={{ style: { padding: TEXT_FIELD_PADDINGS  } }}
              InputProps={{ classes: { notchedOutline: classes.overrideBorder } }}
              InputLabelProps={{ style: { fontWeight: 'bold' } }}
            />
        </div>

      </div>

      <div className={ customsStyles.flexContainer }>
        <div className={ commonStyles.inputLabelWrapper } >
          <label className={ commonStyles.inputLabel }> CES Handling Fee </label>
          <TextField
              disabled
              value={ formatCurrency(serviceDetails.handling_fee, 2, '$') }
              label=""
              variant="outlined"
              inputProps={{ style: { padding: TEXT_FIELD_PADDINGS  } }}
              InputProps={{ classes: { notchedOutline: classes.overrideBorder } }}
              InputLabelProps={{ style: { fontWeight: 'bold' } }}
            />
        </div>
      </div>

      <div className={ customsStyles.flexContainer }>
        <div className={ commonStyles.inputLabelWrapper } >
          <label className={ commonStyles.inputLabel }> In-Bond Fee  </label>
          <TextField
            disabled
            label=""
            value={ formatCurrency(serviceDetails.in_bond_fee, 2, '$') }
            variant="outlined"
            inputProps={{ style: { padding: TEXT_FIELD_PADDINGS  } }}
            InputProps={{ classes: { notchedOutline: classes.overrideBorder } }}
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
          />
        </div>

        <div className={ commonStyles.inputLabelWrapper } >
          <label className={ commonStyles.inputLabel }> {"MIN Cost"}  </label>
          <TextField
            disabled
            label=""
            defaultValue={ formatCurrency(minCost ? minCost : 0, 2, '$') + ' / AWB' + (minCostIsPerDay? " / Day": "") }
            variant="outlined"
            inputProps={{ style: { padding: TEXT_FIELD_PADDINGS  } }}
            InputProps={{ classes: { notchedOutline: classes.overrideBorder } }}
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
          />
        </div>
      </div>

      <div className={ customsStyles.flexContainer }>
        <div className={ customsStyles.horizontalLine }></div>
        <div className={ commonStyles.inputLabelWrapper } >
          <label className={ commonStyles.inputLabel }> Total Cost  </label>
          <TextField
            disabled
            label=""
            value={ formatCurrency(total, 2, '$') }
            variant="outlined"
            inputProps={{ style: { padding: TEXT_FIELD_PADDINGS  } }}
            InputProps={{ classes: { notchedOutline: classes.overrideBorder } }}
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
          />
        </div>
      </div>

      <div className= { ` ${ customsStyles.addInfoWrapper } ${ commonStyles.inputLabelWrapper }` }>
        <label className={ commonStyles.inputLabel }>  Additional information to GHA </label>
        <TextField
          fullWidth={ true }
          id="outlined-disabled"
          label=""
          variant="outlined"
          onChange={ (event) => props.handleChange(event, 'additionalInformation') }
          value={ additionalInformation }
          inputProps={{ style: { padding: TEXT_FIELD_PADDINGS } }}
          InputProps={{ classes: { notchedOutline: classes.overrideBorder } }}
          InputLabelProps={{ shrink: true }}
        />
      </div>
    </FormControl>
  );
}

export default withStyles(styles)(CustomsFee);